import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'rackLocation' })
export class RackLocationPipe implements PipeTransform {
  transform(row: number, col: number): string {
    var columnName: string[] = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"];
    if(row && col && col > 0)
      return columnName[col - 1] + (row)
    return "";
  }
}
